import { Component, OnInit } from '@angular/core';
import { TypeRecompenseService } from '../../services/type-recompense.service';

@Component({
  selector: 'app-type-reward-adder',
  templateUrl: './type-reward-adder.component.html',
  styleUrls: ['./type-reward-adder.component.scss'],
})
export class TypeRewardAdderComponent implements OnInit {
  typeRewardList: any[];
  categoryData = [];

  constructor(private typereward: TypeRecompenseService) {}

  ngOnInit(): void {
    this.typereward.getAllRewardType().subscribe((data) => {
      // this.categoryList = data;
      console.log(data);
      this.typeRewardList = data.map((treward: any) => {
        return {
          label: treward.libelle,
          isEditing: false,
          id: treward.typerecompenseid,
        };
      });
      console.log(
        'les categories disponible : ',
        this.typeRewardList,
        this.isAdding
      );
    });
  }

  newAddedValue: string = 'Nouveau type de recompense';
  isAdding: boolean = false;

  toggleAdding() {
    this.isAdding = true;
  }

  addRewardType() {
    try {
      if (this.newAddedValue?.length > 3) {
        this.typereward
          .createRewardType(this.newAddedValue)
          .subscribe((data) => {
            this.typeRewardList.push({
              isEditing: false,
              label: data.libelle,
              id: data.typerecompenseid,
            });
            this.isAdding = false;
            this.newAddedValue = '';
          });
      }
    } catch (error) {
      console.log('Les erreurs :', error);
    }
  }

  cancelAdding() {
    this.isAdding = false;
    this.newAddedValue = '';
  }

  deleteCategory(id: number) {
    this.typereward.deleteRewardType(id).subscribe((data) => {
      console.log('categorie supprimer avec succes...');
    });

    this.typeRewardList = this.typeRewardList.filter(
      (typereward) => typereward.id != id
    );
  }

  editCategory(id: number) {
    this.typeRewardList[id].isEditing = !this.typeRewardList[id].isEditing;
  }

  updateTypeReward(newData: any, id: number, typeId: number) {
    this.typeRewardList[id].isEditing = !this.typeRewardList[id].isEditing;
    this.typereward.updateRewardType(newData, typeId);
  }
}
